<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Wrestler 1</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId1" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('color1')" class="col-sm-4 col-form-label">Color 1</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('color1')" v-model="color1" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title1')" class="col-sm-4 col-form-label">Name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title1')" v-model.lazy="title1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('score1')" class="col-sm-4 col-form-label">Score 1</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('score1')" v-model="score1" :options="scoreOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club1')" class="col-sm-4 col-form-label">Club 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club1')" v-model.lazy="club1">
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Wrestler 2</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId2" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('color2')" class="col-sm-4 col-form-label">Color 2</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('color2')" v-model="color2" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title2')" class="col-sm-4 col-form-label">Name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title2')" v-model.lazy="title2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('score2')" class="col-sm-4 col-form-label">Score 2</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('score2')" v-model="score2" :options="scoreOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club2')" class="col-sm-4 col-form-label">Club 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club2')" v-model.lazy="club2">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle')" v-model.lazy="patternTitle">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternScore')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore')" v-model.lazy="patternScore">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternClub')" class="col-sm-4 col-form-label">Club</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternClub')" v-model.lazy="patternClub">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label :for="safeId('allowSameColor')" class="col-sm-4 col-form-label">Allow same color</label>
          <div class="col-sm-8" style="padding-top: 5px">
            <b-form-checkbox :id="safeId('allowSameColor')" v-model="allowSameColor"></b-form-checkbox>
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData, mapTemplateData, mapTemplateOptions } from '../../utils/index'

export default {
  name: 'swiss-wrestling-result',
  mixins: [templateMixin],
  computed: {
    ...mapOverlayData(['color1', 'color2', 'title1', 'title2', 'score1', 'score2', 'club1', 'club2']),
    ...mapTemplateData(['datasetId', 'recordId1', 'recordId2']),
    ...mapTemplateData({
      /* eslint-disable no-template-curly-in-string */
      patternColor: {default: '${COLOR}'},
      patternTitle: {default: '${NAME}'},
      patternScore: {default: '${NOTE}'},
      patternClub: {default: '${CLUB}'}
      /* eslint-enable no-template-curly-in-string */
    }),
    ...mapTemplateOptions({'allowSameColor': false}),
    dataset () {
      if (!this.datasetId) return null
      return this.$store.getters.dataset(this.datasetId)
    },
    datasetColumns () {
      if (!this.dataset) return
      return this.dataset.columns || []
    },
    colorOptions () {
      return {'hell': 'Hell', 'dunkel': 'Dunkel'}
    },
    scoreOptions () {
      return ['', '10.00', '9.75', '9.00', '8.75', '8.50']
    }
  },
  watch: {
    recordId1: function (val) {
      if (!val) return
      let record = this.$store.getters.dataset(this.datasetId).records
        .find(r => r.recordId === val)
      if (!record) return
      record = this.mapRecord(record)
      this.color1 = record.color
      this.title1 = record.title
      this.score1 = record.score
      this.club1 = record.club
    },
    recordId2: function (val) {
      if (!val) return
      let record = this.$store.getters.dataset(this.datasetId).records
        .find(r => r.recordId === val)
      if (!record) return
      record = this.mapRecord(record)
      this.color2 = record.color
      this.title2 = record.title
      this.score2 = record.score
      this.club2 = record.club
    },
    color1: function (val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell'
      }
    },
    color2: function (val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell'
      }
    }
  },
  methods: {
    mapRecord (record) {
      const result = {}
      const recordMap = {
        color: this.patternColor,
        title: this.patternTitle,
        score: this.patternScore,
        club: this.patternClub
      }
      for (let k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || ''
        })
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/swiss-wrestling-result.vue